import React from 'react';

interface ChipProps {
  label: string;
  color: string;
  backgroundColor: string;
}
const Chip = ({ label, color, backgroundColor }: ChipProps) => {
  return (
    <div
      className="staus_chip"
      style={{
        color,
        backgroundColor,
        padding: '5px 10px',
        borderRadius: '8px',
        fontWeight: 500,
        display: 'inline-block',
        fontSize: '12px',
      }}
    >
      {label}
    </div>
  );
};

export default Chip;
